import { ReactElement } from "react";
import {
    Box,
    Button,
    ButtonColors,
    ButtonVariants,
    flexidaoGrey,
    NotificationVariant,
    showNotification,
} from "@flexidao/ui-lib";

type ReadonlyCodeAreaProps = {
    content: string;
    styles?: {
        backgroundColor?: string;
        borderColor?: string;
    };
};

export const ReadonlyCodeArea = ({ content, styles }: ReadonlyCodeAreaProps): ReactElement => {
    const backgroundColor = styles?.backgroundColor ?? flexidaoGrey[0];
    const borderColor = styles?.borderColor ?? flexidaoGrey[3];

    return (
        <Box sx={{ position: "relative" }}>
            <pre
                style={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-all",
                    overflowWrap: "break-word",
                    margin: 0,
                    paddingBlock: "4px",
                    paddingInline: "8px",
                    backgroundColor,
                    borderRadius: "4px",
                    border: `1px solid ${borderColor}`,
                    color: flexidaoGrey[9],
                    height: "350px",
                    overflow: "auto",
                    scrollbarWidth: "thin",
                    fontSize: "12px",
                }}
            >
                {content}
            </pre>

            <Box
                sx={{
                    width: "fit-content",
                    position: "absolute",
                    top: 6,
                    right: 12,
                    zIndex: 1,
                }}
            >
                <Button
                    dataId="copy-button"
                    variant={ButtonVariants.Subtle}
                    color={ButtonColors.Green}
                    onClick={(): void => {
                        navigator.clipboard
                            .writeText(content)
                            .then((): void => {
                                showNotification({
                                    variant: NotificationVariant.Success,
                                    message: "The content has been copied to your clipboard",
                                });
                            })
                            .catch((): void => {
                                showNotification({
                                    variant: NotificationVariant.Error,
                                    message: "Failed to copy the content. Please try again later.",
                                });
                            });
                    }}
                >
                    Copy
                </Button>
            </Box>
        </Box>
    );
};
